import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { StoreProvider } from './app/providers/StoreProvider'
import { App } from './App'
import './css/account.css';
import './css/fancybox.min.css';
import './css/media.css';
import './css/reset.css';
import './css/styles.bundle.css';
import './css/swiper.min.css';
import './css/style.min.css';
import './App.css';
import { initAuth } from './app/initAuth';
import { useAuthInit } from '@/features/auth/hooks/useAuthInit';
initAuth();

// 🛡️ Игнорируем ошибки от расширений
window.addEventListener('error', function (event) {
    if (
        event.filename?.startsWith('chrome-extension://') ||
        event.message?.includes('chrome-extension://')
    ) {
        event.preventDefault()
    }
})

window.addEventListener('unhandledrejection', function (event) {
    const reason = event.reason
    if (
        typeof reason === 'object' &&
        reason?.stack?.includes('chrome-extension://')
    ) {
        event.preventDefault()
    }
})



ReactDOM.createRoot(document.getElementById('root')!).render(

    <StoreProvider>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </StoreProvider>
)
